<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-row :gutter="12">
      <a-col :span="12" v-for="(report,index) in reportList" :key="index" >
        <a-card :title="report.postName" style="width: 300px">
          <template #extra><font color="red">{{report.wage}}元</font></template>
          <p>报备时间: {{report.reportTime}}</p>
          <p>公司名称: {{report.companyName}}</p>
          <p>入职时间: {{report.entryTime}}</p>
          <p>离职时间: {{report.dimissionTime}}</p>
        </a-card>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script>
import { queryReportListById } from '@/api/biz/user'
export default {
  name: 'ReportForm',
  data () {
    return {
      formTitle: null,
      open: false,
      reportList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(id) {
      this.open = true
      this.formTitle = '报备记录'
      const param = { id: id }
      queryReportListById(param).then(response => {
        this.reportList = response.data
      })
    },
    onClose () {
      this.open = false
    }
  }
}

</script>

<style scoped>

</style>
